import { useState, useEffect } from 'react';

export const CONSENT_KEY = 'monquiz_cookie_consent';

export function hasAnalyticsConsent() {
    return localStorage.getItem(CONSENT_KEY) === 'accepted';
}

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem(CONSENT_KEY);
        if (!consent) {
            setVisible(true);
        }
    }, []);

    const accept = () => {
        localStorage.setItem(CONSENT_KEY, 'accepted');
        setVisible(false);
        // Activer GA si le script est present
        if (window.gtag) {
            window.gtag('consent', 'update', {
                analytics_storage: 'granted',
            });
        }
    };

    const refuse = () => {
        localStorage.setItem(CONSENT_KEY, 'refused');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner">
            <div className="cookie-banner-inner">
                <p>
                    Ce site utilise Google Analytics pour mesurer l'audience et am&eacute;liorer votre exp&eacute;rience.
                    Aucune donn&eacute;e personnelle n'est revendue.
                </p>
                <div className="cookie-banner-actions">
                    <button onClick={refuse} className="btn btn-outline btn-sm">Refuser</button>
                    <button onClick={accept} className="btn btn-primary btn-sm">Accepter</button>
                </div>
            </div>
        </div>
    );
}
